(function(){
  function favInline(){
    document.querySelectorAll('.product-form__buttons-row').forEach(function(row){
      var info=row.closest('.product__info-container')||document;
      var fav=info.querySelector('.shopify-app-block[id*="customer_hub_wishlist"]');
      var add=row.querySelector('button[name="add"]');
      if(!add||add.closest('.ea-atc-line'))return;
      if(!fav){
        /* Templates without the Klaviyo favorites block (bonbons, smeg, etc.): build the same heart */
        var pin=(row.closest('form')||info).querySelector('input[name="product-id"]');
        var pid=(pin&&pin.value)||(window.ShopifyAnalytics&&ShopifyAnalytics.meta&&ShopifyAnalytics.meta.product&&ShopifyAnalytics.meta.product.id);
        if(!pid)return;
        fav=document.createElement('div');fav.className='shopify-app-block';fav.id='ea-fallback-customer_hub_wishlist';
        fav.innerHTML='<klaviyo-favorites-button product-id="'+pid+'" class="klaviyo-wishlist-slot kl-hub-favorites-slot"></klaviyo-favorites-button>';
      }
      fav.classList.add('ea-fav-inline');
      var line=document.createElement('div');line.className='ea-atc-line';
      add.parentNode.insertBefore(line,add);line.appendChild(add);line.appendChild(fav);
    });
  }
  function favHeader(){
    var row=document.querySelector('.header__icons');
    if(!row||row.querySelector('.ea-fav-header'))return;
    var en=(document.documentElement.lang||'').toLowerCase().indexOf('en')===0;
    var label=en?'My favorites':'Mes favoris';
    var c=document.createElement('div');c.className='header_icon--container ea-fav-header-wrap';
    c.innerHTML='<button type="button" class="header__icon link link--text focus-inset ea-fav-header" aria-label="'+label+'" title="'+label+'"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.6 8.4 3.5 4.5 7.2 4.5c2.1 0 3.6 1.2 4.8 2.9 1.2-1.7 2.7-2.9 4.8-2.9 3.7 0 5.6 3.9 4.5 6.8-1.8 4.6-9.3 9.2-9.3 9.2z"/></svg></button>';
    row.insertBefore(c,row.lastElementChild);
    c.querySelector('button').addEventListener('click',function(){
      if(window.customerHubApi&&window.customerHubApi.open){window.customerHubApi.open('/favorites')}
      else{location.hash='k-hub/favorites'}
    });
  }
  /* Hide Klaviyo star badges that show 0 reviews ("0 avis" / "0 reviews") */
  function hideZeroReviews(){
    document.querySelectorAll('.kl_reviews__star_rating_widget__label').forEach(function(l){
      var w=l.closest('.klaviyo-star-rating-widget')||l.closest('.kl_reviews__star_rating_widget');
      if(!w)return;
      w.style.display=/^\s*0(\s|$)/.test(l.textContent)?'none':'';
    });
  }
  function watchReviews(){
    hideZeroReviews();
    var t;new MutationObserver(function(){clearTimeout(t);t=setTimeout(hideZeroReviews,150);}).observe(document.body,{childList:true,subtree:true});
  }
  /* Side cart: "Petits plus à ajouter" from collection petits-cadeaux-moins-de-25 */
  var EA_UPS={handle:'petits-cadeaux-moins-de-25',max:4,list:null,loading:false};
  function upsEn(){return (document.documentElement.lang||'').toLowerCase().indexOf('en')===0;}
  function upsPrice(p){var n=parseFloat(p);return upsEn()?'$'+n.toFixed(2):n.toFixed(2).replace('.',',')+' $';}
  function upsLoad(cb){
    if(EA_UPS.list)return cb(EA_UPS.list);
    if(EA_UPS.loading)return;EA_UPS.loading=true;
    var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    fetch(root+'collections/'+EA_UPS.handle+'/products.json?limit=40').then(function(r){return r.json()}).then(function(d){
      EA_UPS.list=(d.products||[]).map(function(p){var v=(p.variants||[]).filter(function(x){return x.available})[0];if(!v)return null;
        return {id:p.id,vid:v.id,title:p.title,price:v.price,img:(p.images&&p.images[0]&&p.images[0].src)||'',url:root+'products/'+p.handle};}).filter(Boolean);
      EA_UPS.loading=false;cb(EA_UPS.list);
    }).catch(function(){EA_UPS.loading=false;});
  }
  /* Syrup pump reminders: the right pump for the bottle in the cart */
  var EA_PUMPS=[
    {pid:4967453786247,vid:34003452067975,price:'6.49',fr:'Pompe à sirop Monin 750 ml',en:'Monin 750 ml syrup pump',match:function(i){return /monin/i.test(i.vendor)&&/750\s?ml/i.test(i.t)}},
    {pid:6536352497819,vid:39251317457051,price:'6.99',fr:'Pompe à sirop Monin 1 L',en:'Monin 1 L syrup pump',match:function(i){return /monin/i.test(i.vendor)&&/(^|[^\d,.])1\s?l\b/i.test(i.t)}},
    {pid:9712587440387,vid:49747373981955,price:'6.99',fr:'Pompe à sirop Le Fit Cook',en:'Le Fit Cook syrup pump',match:function(i){return /fit cook/i.test(i.vendor)&&/sirop|syrup/i.test(i.t)}}
  ];
  var EA_PUMP_IDS=EA_PUMPS.map(function(p){return p.pid});
  function upsRender(){
    var drawer=document.getElementById('CartDrawer');if(!drawer)return;
    var inner=drawer.querySelector('.drawer__inner');var footer=drawer.querySelector('.drawer__footer');
    var old=drawer.querySelector('.ea-ups');
    if(!inner||!footer||inner.classList.contains('is-empty')){if(old)old.remove();return;}
    if(old&&old.dataset.ready==='1')return;
    var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    upsLoad(function(list){
      fetch(root+'cart.js').then(function(r){return r.json()}).then(function(cart){
        var inCart={};(cart.items||[]).forEach(function(i){inCart[i.product_id]=1;});
        var need=EA_PUMPS.filter(function(p){return !inCart[p.pid]&&(cart.items||[]).some(function(i){var it={vendor:i.vendor||'',t:i.product_title||i.title||''};return !/^pompe|pump/i.test(it.t)&&p.match(it);});});
        var showPump=need.length>0;
        var picks=list.filter(function(p){return !inCart[p.id]&&EA_PUMP_IDS.indexOf(p.id)<0});
        for(var i=picks.length-1;i>0;i--){var j=Math.floor(Math.random()*(i+1));var t=picks[i];picks[i]=picks[j];picks[j]=t;}
        picks=picks.slice(0,EA_UPS.max);
        var box=drawer.querySelector('.ea-ups');
        if(!picks.length&&!showPump){if(box)box.remove();return;}
        if(!box){box=document.createElement('div');box.className='ea-ups';var f=drawer.querySelector('.drawer__footer');if(!f)return;f.parentNode.insertBefore(box,f);}
        var en=upsEn();
        var pump=need.map(function(p){return '<div class="ea-pump"><span class="ea-pump__txt">'+(en?'<strong>Don’t forget your pump!</strong> '+p.en:'<strong>N’oubliez pas votre pompe!</strong> '+p.fr)+' · '+upsPrice(p.price)+'</span><button type="button" class="ea-ups__add ea-pump__add" data-vid="'+p.vid+'">'+(en?'Add':'Ajouter')+'</button></div>';}).join('');
        var row=picks.length?'<p class="ea-ups__title">'+(en?'Little extras to add 🎁':'Petits plus à ajouter 🎁')+'</p><div class="ea-ups__row">'+picks.map(function(p){
          return '<div class="ea-ups__card"><a href="'+p.url+'" class="ea-ups__img"><img src="'+p.img.replace(/(\.[a-z]+)(\?|$)/i,'_200x$1$2')+'" alt="" loading="lazy"></a><a href="'+p.url+'" class="ea-ups__name">'+p.title.replace(/[<>]/g,'')+'</a><span class="ea-ups__price">'+upsPrice(p.price)+'</span><button type="button" class="ea-ups__add" data-vid="'+p.vid+'">'+(en?'Add':'Ajouter')+'</button></div>';
        }).join('')+'</div>':'';
        box.innerHTML=pump+row;
        box.dataset.ready='1';
      });
    });
  }
  function upsAdd(btn){
    var cd=document.querySelector('cart-drawer');btn.disabled=true;btn.textContent='…';
    var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:+btn.dataset.vid,quantity:1}],sections:'cart-drawer,cart-icon-bubble',sections_url:location.pathname})})
      .then(function(r){return r.json()}).then(function(res){
        if(res&&res.sections&&cd&&cd.renderContents){cd.renderContents(res);}else{location.reload();}
      }).catch(function(){btn.disabled=false;btn.textContent=upsEn()?'Add':'Ajouter';});
  }
  function watchCart(){
    document.addEventListener('click',function(e){var b=e.target.closest&&e.target.closest('.ea-ups__add');if(b){e.preventDefault();upsAdd(b);}});
    var cd=document.querySelector('cart-drawer');if(!cd)return;
    var t;new MutationObserver(function(){clearTimeout(t);t=setTimeout(upsRender,120);}).observe(cd,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});
    upsRender();
  }
  function run(){favInline();favHeader();watchReviews();watchCart();}
  if(document.readyState!=='loading')run();else document.addEventListener('DOMContentLoaded',run);
})();
